import { render } from "./Invites.vue?vue&type=template&id=c45e08b0&scoped=true"
import script from "./Invites.vue?vue&type=script&lang=js"
export * from "./Invites.vue?vue&type=script&lang=js"

import "./Invites.vue?vue&type=style&index=0&id=c45e08b0&scoped=true&lang=sass"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45e08b0"]])

export default __exports__